define("shared/utils/constants/linkinbio-colors", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.TEXT_COLORS = _exports.BACKGROUND_COLORS = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  const TEXT_COLORS = _exports.TEXT_COLORS = Object.freeze({
    LIGHT: '#FFFFFF',
    DARK: '#080808'
  });
  const BACKGROUND_COLORS = _exports.BACKGROUND_COLORS = Object.freeze({
    BUTTON: ['#FFFFFF', '#080808', '#ED4F55', '#FD612C', '#BB8B00', '#31A1AE', '#62BB35', '#3994FC', '#AA71FF', '#8DA3A6'],
    PAGE: ['#FFFFFF', '#3B3B3B', '#F27D82', '#FD865D', '#F0B200', '#48BECB', '#7DCF54', '#6DB0FD', '#C8A3FF', '#A9BABC']
  });
});